<template>
    <div class="supply-hall">
        <div class="container-box">
            <div class="container">
                <!-- 左侧分类导航 -->
                <div class="category-sidebar">
                    <div class="category-item" v-for="(category, index) in categories" :key="category.aid"
                        :class="{ active: selectedCategory === category.aid }"
                        @click="selectCategory(category.aid, index)">
                        {{ category.name }}
                    </div>
                </div>

                <!-- 右侧商品内容 -->
                <div class="product-content">
                    <!-- 顶部大标题 -->
                    <div class="content-title">
                        {{ currentCategory ? currentCategory.name : '商品分类' }}
                    </div>

                    <!-- 子分类导航 - 按二级分组展示三级 goods，默认三行，超出可展开 -->
                    <div class="sub-category-nav" v-if="currentCategory && currentCategory.children">
                        <!-- 子分类组（二级） -->
                        <div class="sub-category-group" v-for="(group, groupIndex) in currentCategory.children"
                            :key="groupIndex">
                            <div class="group-title-row">
                                <div class="group-title"
                                    :class="{ active: selectedSubCategory === group.aid && !selectedGoods }"
                                    @click="selectSubCategory(group.aid)">{{ group.name }}</div>
                                <span class="group-more" v-if="groupOverflow[groupIndex]"
                                    :class="{ 'is-expanded': expandedGroups[groupIndex] }"
                                    @click="toggleGroup(groupIndex)">
                                    {{ expandedGroups[groupIndex] ? '收起' : '更多' }}
                                    <i class="el-icon-arrow-down"></i>
                                </span>
                            </div>
                            <div class="group-items" :class="{ collapsed: !expandedGroups[groupIndex] }"
                                v-if="group.goods && group.goods.length">
                                <div class="sub-category-item"
                                    v-for="(goods, goodsIndex) in group.goods" :key="goodsIndex"
                                    :class="{ active: selectedGoods === goods.aid }"
                                    @click.stop="selectThirdGoods(group.aid, goods)">
                                    {{ goods.name }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 排序选项 -->
                    <div class="sort-options">
                        <div class="sort-item" @click="sortFn(1)">推荐</div>
                        <div class="sort-item" @click="sortFn(2)">销量
                            <img src="../../assets/images/22.png" :class="{ 'xuanzhuan': xiaoliangStatus == 'desc' }"
                                alt="">
                        </div>
                        <div class="sort-item" @click="sortFn(3)">价格
                            <img src="../../assets/images/22.png" :class="{ 'xuanzhuan': pricaeStatus == 'desc' }"
                                alt="">
                        </div>
                        <el-dropdown trigger="hover" popper-class="province-dropdown">
                            <div class="sort-item">
                                {{ provinceName || '全国' }}
                                <img src="../../assets/images/23.png" alt="" style="width: 6px;height: 6px;">
                            </div>
                            <el-dropdown-menu slot="dropdown">
                                <div class="province-list">
                                    <div v-for="province in provinces" :key="province.aid" class="province-item"
                                        @click="selectProvince(province)">
                                        {{ province.province_name }}
                                    </div>
                                </div>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <div class="sort-item">附近货源</div>
                    </div>

                    <!-- 商品列表 -->
                    <el-empty description="暂无数据" v-if="products.length == 0"></el-empty>

                    <div class="product-list" v-else>
                        <div class="product-item" v-for="product in products" :key="product.id"
                            @click="goDetails(product)">
                            <div class="product-image">
                                <img :src="product.thumb" :alt="product.name">
                            </div>
                            <div class="product-info">
                                <div class="product-name">{{ product.name }}</div>
                                <div class="product-price-sales">
                                    <div class="product-price">¥{{ product.shop_price }}/{{ product.unit }}</div>
                                    <div class="product-sales">销量 {{ product.sales_sum }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <!-- 分页控件 -->
            <div class="pagination-container">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-sizes="[12, 24, 48, 60]" :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="totalOrders">
                </el-pagination>
            </div>

        </div>


    </div>
</template>

<script>
export default {
    name: 'SupplyHall',
    data() {
        return {
            selectedCategory: 0, // 当前选中的id
            selectedCategoryIndex: 0, // 当前选中的分类索引
            categories: [],
            selectedSubCategory: '',//当前选中的二级id
            selectedGoods: '', // 当前选中的三级 goods aid
            searchKeyword: '', // 三级分类搜索关键词
            products: [],
            provinces: [],
            provinceCode: '',
            sort_field: '1',
            sort_type: 'asc', //desc 倒序

            xiaoliangStatus: 'asc', // 销量排序状态
            pricaeStatus: 'asc', // 价格排序状态

            // 分页数据
            currentPage: 1,
            pageSize: 24,
            totalOrders: 0,

            locationInfo: {},
            provinceName: '',

            expandedGroups: {}, // 展开状态：key 为二级分组索引
            groupOverflow: {},  // 三级是否超出三行
        }
    },
    mounted() {
        this.getHomeShopFenlei();
        this.getChandiList();

        try {
            this.locationInfo = JSON.parse(localStorage.getItem('locationInfo'));
        } catch (e) {
            this.locationInfo = {};
        }

        console.log(this.locationInfo, 'this.locationInfo');
    },
    computed: {
        // 添加当前选中分类的计算属性
        currentCategory() {
            // 优先通过索引查找
            const categoryByIndex = this.categories[this.selectedCategoryIndex];
            if (categoryByIndex && categoryByIndex.aid === this.selectedCategory) {
                return categoryByIndex;
            }

            // 如果索引查找失败，通过aid查找
            return this.categories.find(category => category.aid === this.selectedCategory) || null;
        },
        cityCode() {
            return this.$store.getters.getCityCode[1];
        }
    },

    props: {
        fenleObj: {
            type: Object,
            default: () => ({})
        },
        keyword: {
            type: String,
            default: ''
        },
    },
    watch: {
        fenleObj: {
            handler(newVal) {
                console.log('fenleObj 变化了', newVal);
                if (Object.keys(newVal).length > 0) {
                    this.selectedCategory = newVal.pid;
                    // 根据aid找到对应的索引
                    this.selectedCategoryIndex = this.categories.findIndex(category => category.aid === newVal.pid) || 0;
                }
            },
            deep: true
        },
        cityCode(newVal, oldVal) {
            this.getSupplyHallList()
        },
        keyword(newVal, oldVal) {
            this.getSupplyHallList()
        },
    },
    methods: {
        // 展开/收起某个二级分组的三级列表
        toggleGroup(groupIndex) {
            this.$set(this.expandedGroups, groupIndex, !this.expandedGroups[groupIndex]);
        },

        // 三级超出 6 条则显示"更多/收起"
        checkOverflow() {
            const children = (this.currentCategory && this.currentCategory.children) || [];
            children.forEach((group, groupIndex) => {
                this.$set(this.groupOverflow, groupIndex, !!(group.goods && group.goods.length > 6));
            });
        },

        // 选择左侧一级id
        selectCategory(aid, index) {
            this.selectedCategory = aid;
            this.selectedCategoryIndex = index;
            console.log(this.categories[index].children);

            // 默认选中"全部"，cid 传当前一级分类 id
            this.selectedSubCategory = aid;
            this.selectedGoods = '';
            this.searchKeyword = ''; // 切换分类时清空关键词
            this.currentPage = 1;
            this.expandedGroups = {}; // 切换分类时重置展开状态
            this.getSupplyHallList()
            this.checkOverflow();
        },
        //选择二级id
        selectSubCategory(aid) {
            this.selectedSubCategory = aid;
            this.selectedGoods = '';
            this.searchKeyword = ''; // 切换分类时清空关键词
            this.currentPage = 1; // 切换分类时重置分页
            this.getSupplyHallList()
        },
        // 选择三级分类：cid 仍传二级 aid，关键词用三级名称
        selectThirdGoods(groupAid, goods) {
            this.selectedSubCategory = groupAid;
            this.selectedGoods = goods.aid;
            this.searchKeyword = goods.name;
            this.currentPage = 1;
            this.getSupplyHallList()
        },
        selectProvince(province) {
            console.log('Selected province:', province);
            this.provinceCode = province.place_of_dispatch_province;
            this.provinceName = province.province_name;
            // 这里可以添加省份选择后的逻辑
            this.getSupplyHallList()
        },

        // 获取分类数据
        getHomeShopFenlei() {
            this.$api.getHomeShopFenlei().then(res => {
                let list = res;
                this.categories = list;

                console.log(this.fenleObj, 'this.fenleObj111', this.categories);
                console.log(list, 'list');

                if (list.length > 0) {

                    // 如果有传入的fenleObj，优先使用它
                    if (Object.keys(this.fenleObj).length > 0) {
                        this.selectedCategory = this.fenleObj.pid;
                        this.selectedCategoryIndex = this.categories.findIndex(category => category.aid == this.fenleObj.pid) || 0;
                        this.selectedSubCategory = this.fenleObj.aid;
                    } else {
                        // 设置默认选中第一个分类
                        this.selectedCategory = list[0].aid;
                        this.selectedCategoryIndex = 0;
                        // 默认选中"全部"，cid 传当前一级分类 id
                        this.selectedSubCategory = list[0].aid;
                    }
                    console.log('结果');

                    this.getSupplyHallList()
                    this.checkOverflow();


                }
            }).catch(err => {
                // this.$message.error(err);
            })
        },

        // 获取商品列表
        getSupplyHallList() {
            let data = {
                cid: this.selectedSubCategory,
                goods_type: 1,
                // max_price: this.max_price,
                // min_price: this.min_price,
                // update_time: this.brand_id,
                place_of_dispatch_province: this.provinceCode,
                keyword: this.searchKeyword || this.keyword,
                sort: this.sort_field,
                order: this.sort_type,
                page: this.currentPage,
                list_rows: this.pageSize,
                // classification: this.tabsTypefd2_0,
                region_code: this.cityCode,
                lat: this.locationInfo ? this.locationInfo.lat : '',
                lng: this.locationInfo ? this.locationInfo.lng : '',


            }
            this.$api.getSupplyHallList(data).then(res => {
                this.products = res.data;
                this.totalOrders = res.total;
            }).catch(err => {
                // this.$message.error(err);
            })
        },

        // 获取产地列表
        getChandiList() {
            this.$api.getChandiList().then(res => {
                this.provinces = res;
                this.provinces.unshift({
                    aid: '',
                    place_of_dispatch_province: "",
                    province_name: "全国"
                })

                console.log(this.provinces, 'this.provinces');

            }).catch(err => {
                // this.$message.error(err);
            })
        },

        // 跳转详情页
        goDetails(product) {
            this.$router.push({
                path: '/ShopDetails',
                query: {
                    id: product.id
                }
            })
        },

        // 分页方法
        handleSizeChange(val) {
            this.pageSize = val;
            this.getSupplyHallList();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getSupplyHallList();
        },

        // 排序方法
        sortFn(type) {
            if (type == 2) {
                // 销量
                this.sort_type = this.sort_type == 'asc' ? 'desc' : 'asc'
                this.xiaoliangStatus = this.sort_type == 'asc' ? 'desc' : 'asc'
            } else if (type == 3) {
                // 价格
                this.sort_type = this.sort_type == 'asc' ? 'desc' : 'asc'
                this.pricaeStatus = this.sort_type == 'asc' ? 'desc' : 'asc'
            }
            this.sort_field = type
            this.getSupplyHallList();
        },

    }
}
</script>

<style scoped>
.supply-hall {
    background-color: #f5f5f5;
    min-height: calc(100vh - 120px);
    padding: 20px 0;
}

.container-box {
    width: 1200px;
    margin: 0 auto;
}

.container {

    display: flex;
    gap: 20px;
}

/* 左侧分类导航 */
.category-sidebar {
    width: 120px;
    background-color: #ffffff;
    border-radius: 8px;
    padding: 15px 0;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

.category-item {
    padding: 12px 20px;
    font-size: 14px;
    color: #333333;
    cursor: pointer;
    transition: all 0.3s;
    text-align: center;
}

.category-item:hover {
    color: #286CED;
    background-color: #f0f4ff;
}

.category-item.active {
    color: #ffffff;
    background-color: #286CED;
    font-weight: 500;
}

/* 右侧商品内容 */
.product-content {
    flex: 1;
    background-color: #ffffff;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
    padding: 20px;
}

/* 内容标题 */
.content-title {
    display: flex;
    font-size: 24px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 20px;
}

/* 子分类导航 */
.sub-category-nav {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 30px 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #e0e0e0;
    margin-bottom: 20px;
}

/* 子分类组（二级） */
.sub-category-group {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

/* 组标题 */
.group-title {
    font-size: 14px;
    font-weight: bold;
    color: #333333;
    text-align: left;
    cursor: pointer;
    transition: all 0.3s;
    padding: 2px 0;
}

.group-title:hover {
    color: #286CED;
}

.group-title.active {
    color: #286CED;
}

/* 二级标题行：标题 + 更多/收起 */
.group-title-row {
    display: flex;
    align-items: center;
    gap: 6px;
}

.group-more {
    font-size: 12px;
    color: #286CED;
    cursor: pointer;
    white-space: nowrap;
    user-select: none;
    display: inline-flex;
    align-items: center;
    gap: 2px;
}

.group-more:hover {
    text-decoration: underline;
}

.group-more .el-icon-arrow-down {
    font-size: 12px;
    transition: transform 0.3s;
}

.group-more.is-expanded .el-icon-arrow-down {
    transform: rotate(180deg);
}

/* 组内子分类 - 横向平铺换行 */
.group-items {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 20px;
    font-size: 12px;
}

/* 子分类项：固定行高，保证三行高度可计算 */
.sub-category-item {
    font-size: 13px;
    color: #666666;
    line-height: 22px;
    padding: 0;
    cursor: pointer;
    transition: all 0.3s;
    white-space: nowrap;
}

/* 默认收起：只展示前 6 条，第 7 条起隐藏 */
.group-items.collapsed .sub-category-item:nth-child(n+7) {
    display: none;
}

.sub-category-item:hover {
    color: #286CED;
}

.sub-category-item.active {
    color: #286CED;
    font-weight: bold;
}

/* 排序选项 */
.sort-options {
    display: flex;
    gap: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #e0e0e0;
    margin-bottom: 20px;
}

.sort-item {
    font-size: 14px;
    color: #666666;
    cursor: pointer;
    transition: all 0.3s;
    padding: 6px 12px;
    border-radius: 4px;
}

.sort-item:hover {
    color: #286CED;
    background-color: #f0f4ff;
}

.sort-item.active {
    color: #286CED;
    font-weight: bold;
    background-color: #e8f0fe;
}

.sort-item img {
    width: 6px;
    height: 9px;
}

/* 商品列表 */
.product-list {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 20px;
}

.product-item {
    background-color: #ffffff;
    border-radius: 8px;
    overflow: hidden;
    transition: all 0.3s;
    text-align: left;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.product-item:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.product-image {
    width: 100%;
    height: 150px;
    overflow: hidden;
}

.product-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s;
}

.product-item:hover .product-image img {
    transform: scale(1.05);
}

.product-info {
    padding: 12px;
}

.product-name {
    font-size: 14px;
    color: #333333;
    margin-bottom: 8px;
    height: 40px;
    overflow: hidden;
    display: -webkit-box;
    line-clamp: 2;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

.product-price-sales {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.product-price {
    font-size: 16px;
    color: #ff4757;
    font-weight: bold;
}

.product-sales {
    font-size: 12px;
    color: #999999;
}

/* 省份下拉框样式 */
.province-dropdown {
    width: 410px !important;
    padding: 10px;
    border-radius: 8px;
    background-color: #ffffff;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
    border: 1px solid #e0e0e0;
}

.province-list {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 12px;
}

.province-item {
    padding: 8px 12px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s;
    font-size: 14px;
    color: #666666;
    border-radius: 4px;
}

.province-item:hover {
    color: #286CED;
    background-color: #f0f4ff;
}

/* 分页容器 */
.pagination-container {
    background-color: #ffffff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
    text-align: right;
    text-align: center;
    width: 1200px;
    margin: 0 auto;
    margin-top: 20px;

}

.xuanzhuan {
    transform: rotate(180deg);
}

/* 响应式设计 */
@media (max-width: 1200px) {
    .container {
        width: 100%;
        padding: 0 20px;
    }

    .product-list {
        grid-template-columns: repeat(5, 1fr);
    }

}

@media (max-width: 992px) {
    .product-list {
        grid-template-columns: repeat(4, 1fr);
    }

    .province-list {
        grid-template-columns: repeat(4, 1fr);
    }
}

@media (max-width: 768px) {
    .container {
        flex-direction: column;
    }

    .category-sidebar {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        padding: 10px;
    }

    .category-item {
        flex: 1;
        min-width: 80px;
        padding: 10px 15px;
        display: flex;
    }

    .product-list {
        grid-template-columns: repeat(3, 1fr);
    }

    .sort-options {
        flex-wrap: wrap;
    }

    .province-list {
        grid-template-columns: repeat(3, 1fr);
    }
}

@media (max-width: 576px) {
    .product-list {
        grid-template-columns: repeat(2, 1fr);
    }

    .content-title {
        font-size: 20px;
    }

    .sort-options {
        gap: 10px;
    }

    .sort-item {
        font-size: 12px;
        padding: 4px 8px;
    }

    .province-dropdown {
        width: 300px !important;
    }

    .province-list {
        grid-template-columns: repeat(2, 1fr);
    }
}
</style>